<template>
  <div class="flex h-full flex-col justify-between">
    <QueryLoading v-if="isLoading" />
    <QueryError
      v-else-if="isError && data == null"
      class="flex-1"
      :show-retry="true"
      @retry="refetch"
    >
      Failed to retrieve transactions
    </QueryError>
    <TransactionsList
      v-else
      :transactions="transactions"
      class="mb-2"
    />
    <RouterLink
      :to="{ name: 'transactionIndex' }"
      class="shrink-0 text-sm text-primary"
    >
      view all transactions
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
const { data, isError, isLoading, refetch } =
  useTransactions({
    limit: 5,
    offset: 0,
  })

const transactions = computed(() => data.value?.items || [])
</script>
